import { type PropsWithChildren, createElement, memo } from "react";

import { type TTailwindString } from "classnames";

type HeadingLevel = "display" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

type Props = {
  as: Exclude<HeadingLevel, "display">;
  className?: TTailwindString;
  id?: string;
};

const HeadingViewBase = ({
  as,
  children,
  className,
  id,
}: PropsWithChildren<Props>) => {
  return createElement(as, { className, id }, children);
};

export const HeadingView = memo(HeadingViewBase);
